// extracted by mini-css-extract-plugin
module.exports = {"image":"_2xitQz1C82FRIyKwlMWDNM","csrBanner":"_1jByl-sCZXfFYXyFNewhor"};